"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Checkbox_1 = require("office-ui-fabric-react/lib/Checkbox");
var styles = require('./OptionsCheckbox.scss');
var classNames = require('classnames/bind').bind(styles);
function OptionsCheckbox(props) {
    return (React.createElement(Checkbox_1.Checkbox, tslib_1.__assign({}, props, { styles: {
            root: classNames(styles.root, (props.styles || {}).root),
        } })));
}
exports.default = OptionsCheckbox;
//# sourceMappingURL=OptionsCheckbox.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/view/owa-options-controls/lib/components/OptionsCheckbox.js
// module id = 4928
// module chunks = 2